import HousesReport from "../Pages/reports/HousesReport";
import {
  Houses,
  Accounts,
  LandingPage,
  Bills,
  Payments,
  MonthlyReport,
  CollectionReport,
  TermsAndConditions,
  NotFound,
  Users,
  Agents,
  Dashboard,
  AccountDetails,
  TransferReport,
  Disbursement,
  Agent,
  UserRoles,
  UserGroups,
  ChangePassword,
  SearchAccount,
  CollectionAccounts,
  Reconciliation,
  ReconciliationAction,
  AccountsReport,
  Complaints,
  AccountPendingApproval,
  MonthlyPayments,
  DailyPayments,
  PaidAccounts,
  UnPaidAccounts,
  PendingAccounts,
  UnPaidAccountsThisMonth,
  AllAccounts,
  TopDashboard,
  ReceiptVerification,
  InvoiceVerification,
  Videos,
  Support,
  TopLevelDisbursement,
  Audits
} from "./components";

const routes = [
  {
    path: "/*",
    element: <NotFound />,
    requireAuth: true,
  },
  {
    path: "/loggedin/houses",
    element: <Houses />,
    requireAuth: true,
  },
  {
    path: "/loggedin/low-level-dashboard",
    element: <Dashboard />,
    requireAuth: true,
  },
  {
    path: "/loggedin/top-level-dashboard",
    element: <TopDashboard />,
    requireAuth: true,
  },
  {
    path: "/loggedin/accounts",
    element: <Accounts />,
    requireAuth: true,
  },
  {
    path: "/loggedin/bills",
    element: <Bills />,
    requireAuth: true,
  },
  {
    path: "/loggedin/payments",
    element: <Payments />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/users",
    element: <Users />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/agents",
    element: <Agents />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/agents/:agentId",
    element: <Agent />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/user-roles",
    element: <UserRoles />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/user-groups",
    element: <UserGroups />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/audit-logs",
    element: <Audits />,
    requireAuth: true,
  },
  {
    path: "/loggedin/monthly-report",
    element: <MonthlyReport />,
    requireAuth: true,
  },
  {
    path: "/loggedin/accounts-report",
    element: <AccountsReport />,
    requireAuth: true,
  },
  {
    path: "/loggedin/collection-report",
    element: <CollectionReport />,
    requireAuth: true,
  },
  {
    path: "/loggedin/houses-report",
    element: <HousesReport />,
    requireAuth: true,
  },
  {
    path: "/loggedin/transfers",
    element: <TransferReport />,
    requireAuth: true,
  },
  {
    path: "/loggedin/disbursement",
    element: <Disbursement />,
    requireAuth: true,
  },
  {
    path: "/loggedin/top-level-disbursement",
    element: <TopLevelDisbursement />,
    requireAuth: true,
  },
  {
    path: "/loggedin/account/:accountId",
    element: <AccountDetails />,
    requireAuth: true,
  },
  {
    path: "/loggedin/paid-accounts/:locationId",
    element: <PaidAccounts />,
    requireAuth: true,
  },
  {
    path: "/loggedin/unpaid-accounts/:locationId",
    element: <UnPaidAccounts />,
    requireAuth: true,
  },
  {
    path: "/loggedin/unpaid-accounts-this-month/:locationId",
    element: <UnPaidAccountsThisMonth />,
    requireAuth: true,
  },
  {
    path: "/loggedin/all-accounts/:locationId",
    element: <AllAccounts />,
    requireAuth: true,
  },
  {
    path: "/loggedin/pending-accounts/:locationId",
    element: <PendingAccounts />,
    requireAuth: true,
  },
  {
    path: "/loggedin/monthly-payments/:locationId",
    element: <MonthlyPayments />,
    requireAuth: true,
  },
  {
    path: "/loggedin/daily-payments/:locationId",
    element: <DailyPayments />,
    requireAuth: true,
  },
  {
    path: "/loggedin/reconciliation/:period/disbursements/:id",
    element: <ReconciliationAction />,
    requireAuth: true,
  },
  {
    path: "/loggedin/change-password",
    element: <ChangePassword />,
    requireAuth: true,
  },
  {
    path: "/loggedin/search-accounts",
    element: <SearchAccount />,
    requireAuth: true,
  },
  {
    path: "/loggedin/reconciliation",
    element: <Reconciliation />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/collection-accounts",
    element: <CollectionAccounts />,
    requireAuth: true,
  },
  {
    path: "/loggedin/admin/complaints",
    element: <Complaints />,
    requireAuth: true,
  },
  {
    path: "/loggedin/account-pending-approval",
    element: <AccountPendingApproval />,
    requireAuth: true,
  },
  {
    path: "/loggedin/videos",
    element: <Videos />,
    requireAuth: true,
  },
  {
    path: "/loggedin/support",
    element: <Support />,
    requireAuth: true,
  },
  {
    path: "/",
    element: <LandingPage />,
    requireAuth: false,
  },
  {
    path: "/terms",
    element: <TermsAndConditions />,
    requireAuth: false,
  },
  {
    path: "/receipt-verification/:tid",
    element: <ReceiptVerification />,
    requireAuth: false,
  },
  {
    path: "/invoice-verification/:billId",
    element: <InvoiceVerification />,
    requireAuth: false,
  },
];
export default routes;
